import { useEffect, useState } from 'react';

const getScrollTop = (elem: HTMLElement | Window | undefined | null): number => {
  if (!elem) return 0;
  return elem instanceof window.constructor ? window.scrollY : (elem as HTMLElement).scrollTop;
};

export function useScrollPosition(elem: HTMLElement | Window | undefined | null): number {
  const [actualElem, setActualElem] = useState<HTMLElement | Window>();

  useEffect(() => {
    setActualElem(elem ?? window);
  }, [elem]);

  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    setScrollY(getScrollTop(actualElem));
  }, [actualElem]);

  useEffect(() => {
    if (!actualElem) return;
    let ticking = false;
    const handleScroll = () => {
      const y = getScrollTop(actualElem);
      if (!ticking) {
        window.requestAnimationFrame(() => {
          setScrollY(y);
          ticking = false;
        });
        ticking = true;
      }
    };

    actualElem.addEventListener('scroll', handleScroll, { passive: true }); // Passive for performance :contentReference[oaicite:9]{index=9}
    return () => {
      actualElem.removeEventListener('scroll', handleScroll);
    };
  }, [actualElem]);

  return scrollY;
}
